console.log('[error-tap] listeners registered');
window.addEventListener('error', (e) =>
  console.error('[GLOBAL error]', e.message, e.filename, e.lineno, e.error)
);
window.addEventListener('unhandledrejection', (e) =>
  console.error('[GLOBAL promise rejection]', e.reason)
);
